export default __webpack_public_path__ + "static/defaultBlogImage-57cb3dcbada8627c2e6c1f0df267bfa4.webp";